var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-layout',{attrs:{"row":"","mt-4":""}},[_c('v-flex',{attrs:{"xs1":""}},[_c('v-btn',{attrs:{"color":"primary"},on:{"click":function($event){return _vm.$emit('add-hotel')}}},[_vm._v("\n      Add hotel\n    ")])],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-d2e028f4","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/itinerary/itineraryPrices/ItineraryPricesPriceSettingTableActions.vue
// module id = null
// module chunks = 